import React from 'react';
import { useSelector } from 'react-redux';

const Title = ({ title, color_category }) => {
  return (
    <div class='archive-header text-center mt-20'>
      <div class='container'>
        <h2>
          <span
            class='color3'
            style={{
              color: color_category,
            }}
          >
            {title || 'Tin tức'}
          </span>
        </h2>
        <div class='breadcrumb'>
          <a href='/tin-tuc' rel='nofollow'>
            Chuyên mục
          </a>
          <span></span>
        </div>
        <div class='bt-1 border-color-1 mt-30 mb-50'></div>
      </div>
    </div>
  );
};
export default Title;
